import {Component, Input} from '@angular/core';
import {BuildingType, Location} from "@flowmaps-com/flowmaps-typescriptmodels";
import moment from "moment/moment";
import {RefdataUtils} from "../../refdata/refdata-utils";
import {Handler} from "../../../common/handler";
import {View} from "../../../common/view";
import {bestLocationEnergyLabel, EnergyLabels} from "../../common/energy-label/energy-label.component";


@Component({
    selector: 'app-location-energy-label-info',
    templateUrl: './location-energy-label-info.component.html',
    styleUrls: ['./location-energy-label-info.component.scss']
})
@Handler()
export class LocationEnergyLabelInfoComponent extends View {
    refdataUtils = RefdataUtils;
    _location: Location;
    buildingType: BuildingType;

    energyLabels: EnergyLabels[] = [
        EnergyLabels.G,
        EnergyLabels.F,
        EnergyLabels.E,
        EnergyLabels.D,
        EnergyLabels.C,
        EnergyLabels.B,
        EnergyLabels.A,
        EnergyLabels.AA,
        EnergyLabels.AAA,
        EnergyLabels.AAAA,
        EnergyLabels.AAAAA,
        EnergyLabels.AAAAAA
    ];

    @Input()
    set location(location: Location) {
        this._location = location;
        if (location && location.info.buildingType) {
            this.sendQuery("getBuildingType", location.info.buildingType).subscribe(b => this.buildingType = b);
        }
    }

    getEnergyLabelClass = (label: EnergyLabels) => {
        const classes = {
            active: this.isActiveEnergyLabel(label)
        }
        classes[this.getEnergyLabelColorClass(label)] = true;
        return classes;
    }

    getCurrentEnergyLabelClass = () => this.currentEnergyLabel
        ? this.getEnergyLabelColorClass(this.currentEnergyLabel) : 'energy-label-unknown';

    get currentEnergyLabel(): string | null {
        return bestLocationEnergyLabel(this._location);
    }

    get energyLabelArea(): number | null {
        return this.refdataUtils.getLocationArea(this._location) ?? null;
    }

    get energyLabelBuildingType(): string | null {
        return this._location?.refdata?.energyLabelBuildingType || this.buildingType?.info.name || null;
    }

    private getEnergyLabelColorClass(label: string): string {
        const plusCount = (label.match(/\+/g) || []).length;
        return plusCount ? `energy-label-a-plus-${plusCount}` : `energy-label-${label.toLowerCase()}`;
    }

    isActiveEnergyLabel = (label: EnergyLabels) => {
        const energyLabel = bestLocationEnergyLabel(this._location);
        return energyLabel === label;
    }

    formatDate = (date: string) => moment(date).format("DD MMM YYYY");
}
